import actionTypes from './actionTypes';
import { markDownParser } from 'src/utils/markDown';

const initialState = {
  editorial: '',
  isLoading: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_EDITORIAL:
      return {
        ...state,
        isLoading: true,
      };
    case actionTypes.FETCH_EDITORIAL_SUCCESS:
      return {
        ...state,
        isLoading: false,
        editorial: markDownParser(action.rawEditorial),
      };
  };
  return state;
};



// WEBPACK FOOTER //
// ./src/modules/tags/editorial/reducer.js